module.exports = __webpack_public_path__ + "img/sandbox-2.02a01350.png";